/**
 * `Content-Disposition` 에서 내려받을 파일 이름을 꺼낸다 (RFC 6266 / RFC 5987).
 *
 * 한글 이름은 `filename*=UTF-8''…` 에 퍼센트 인코딩으로 오고, `filename=` 은 ASCII 대체다. 그래서
 * 앞의 것을 먼저 본다. 관리자·포털이 함께 쓰므로 어느 쪽 서비스에도 묶지 않고 여기 둔다.
 *
 * @returns 이름. 헤더가 없거나 읽을 수 없으면 null — 호출부가 정한 이름을 쓴다
 */
export const filenameFromDisposition = (disposition: unknown): string | null => {
  if (typeof disposition !== 'string') return null;
  const encoded = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(disposition);
  if (encoded) {
    try {
      return decodeURIComponent(encoded[1].trim());
    } catch {
      // 잘못 인코딩된 이름이면 ASCII 대체로 내려간다
    }
  }
  const plain = /filename\s*=\s*"?([^";]+)"?/i.exec(disposition);
  return plain ? plain[1].trim() : null;
};
